import api from "../../services/api";

const obterDadosTicket = () => {
	const findById = async (ticketId) => {
        const { data } = await api.get(`/tickets/${ticketId}`);
        return data;
    }

	return { findById };
};

export default obterDadosTicket;
